import { Component, OnInit, OnDestroy, Input, ViewChild, ChangeDetectorRef } from '@angular/core';
import { Owner, Country, Provincia, Comune, Company, company, DocTemplate, DocTemplateEntity } from 'toolbandi-ui-lib';
import { Search, ListItem, CrudService, MessageService, SharedDataService, ListService, enumToArray } from 'elbuild-ui-lib-core';
import { ClassType } from 'class-transformer/ClassTransformer';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AttachmentInputComponent } from 'elbuild-ui-componentslib';

@Component({
	selector: 'app-doctemplate-edit',
	templateUrl: './doctemplate-edit.component.html',
	styleUrls: ['./doctemplate-edit.component.scss']
})
export class DoctemplateEditComponent implements OnInit, OnDestroy {

	loading: boolean = false;
	doctemplate: DocTemplate;

	docTemplateTypes = enumToArray(DocTemplateEntity);


	@ViewChild('attachment', {}) attachment: AttachmentInputComponent;


	@Input()
	tenderid: number;

	canupload: boolean;

	constructor(
		private docTemplateService: CrudService<DocTemplate>,
		private messageService: MessageService,
		private translateService: TranslateService,
		private sharedDataService: SharedDataService,
		private route: ActivatedRoute,

		private cdr: ChangeDetectorRef,
		private activeModal: NgbActiveModal,

	) {

	}

	ngOnInit() {
		this.route.params.subscribe(params => {
			const id = +params['id'];
			if (id) {
				this.load(id);
			} else {
				this.doctemplate = new DocTemplate();
				if (this.tenderid)
					this.doctemplate.tenderid = this.tenderid;
			}

		});
	}

	ngOnDestroy() {
		this.sharedDataService.addCommonData('route', undefined);
	}

	load(id: number) {
		this.loading = true;
		this.docTemplateService.getEntity(DocTemplate, 'doctemplate', id).subscribe(res => {
			this.doctemplate = res;
			this.loading = false;
		}, ({ error }) => {
			this.messageService.sendError(error, this.translateService.instant('labels.doctemplate'));
			this.doctemplate = undefined;
			this.loading = false;
		});
	}



	dismiss() {
		this.activeModal.dismiss();
	}

	upload() {
		if (this.attachment?.file) {
			this.canupload = true;
		} else {
			this.success();
		}
	}


	success() {
		const messages = this.translateService.instant(['labels.doctemplate-save-success', 'labels.success']);
		this.messageService.sendSuccess(messages['labels.doctemplate-save-success'], messages['labels.success']);
		this.activeModal.close(this.doctemplate);
	}
	submit() {

		if ((!this.doctemplate.id && !this.attachment?.file) || (this.doctemplate.id && !this.doctemplate.file)) {
			this.messageService.sendIndefineteWarn('E\' necessario caricare un file');
		} else
			if (!this.doctemplate.id) {

				this.docTemplateService.createEntity(DocTemplate, 'doctemplate', this.doctemplate).subscribe(response => {
					this.doctemplate = response;

					console.log('upload');
					this.cdr.detectChanges();
					this.upload();


				}, ({ error }) => {
					this.messageService.sendError(
						error.msg ? error.msg : error,
						this.translateService.instant('labels.event-save-error')
					);
				});
			} else {
				this.docTemplateService.saveEntity(DocTemplate, 'doctemplate', this.doctemplate).subscribe(response => {
					this.doctemplate = response;

					this.cdr.detectChanges();
					this.upload();
				}, ({ error }) => {
					this.messageService.sendError(
						error.msg ? error.msg : error,
						this.translateService.instant('labels.event-save-error')
					);
				});
			}
	}

	autoSlug() {
		if (!this.doctemplate.slug || this.doctemplate.slug == '') {
			this.doctemplate.slug = this.doctemplate.name.split(' ').join('.')
		}
	}

	uploadcomplete(event) {
		console.log('uploadcomplete', event);

		this.success();
	}


}
